<template>
    <div class="ui-page-header c-primary text-align-center">
        <h1 v-if="title">{{ title }}</h1>
        <h3 v-if="subtitle" class="fw-regular">{{ subtitle }}</h3>
    </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: [
    'title',
    'subtitle'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/ui/PageHeader.vue